import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const PageBanner = ({ title, subtitle, image, crumbs = [] }) => {
  return (
    <section className="relative h-[52vh] min-h-[380px] flex items-center overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url(${image})` }} />
      <div className="absolute inset-0 bg-gradient-to-b from-[#304b71]/70 via-[#304b71]/50 to-[#304b71]/85" />
      <div className="relative z-10 max-w-7xl mx-auto px-6 w-full text-white">
        <nav className="flex items-center gap-2 text-sm text-white/80 mb-5">
          <Link to="/" className="hover:text-[#a6b2b5]">Home</Link>
          {crumbs.map((c, i) => (
            <span key={i} className="flex items-center gap-2">
              <ChevronRight size={14} />
              {c.to ? <Link to={c.to} className="hover:text-[#a6b2b5]">{c.label}</Link> : <span className="text-white">{c.label}</span>}
            </span>
          ))}
        </nav>
        <h1 className="font-serif text-4xl md:text-6xl leading-tight max-w-4xl">{title}</h1>
        {subtitle && <p className="mt-4 text-white/85 max-w-2xl text-lg">{subtitle}</p>}
      </div>
    </section>
  );
};

export default PageBanner;
